import { useEffect } from "react";
import {
  canContinueTriviaFeedback,
  shouldHandleTriviaContinueKey,
} from "../utils/triviaFeedbackContinue";

export function useTriviaFeedbackContinueHotkeys({
  phase,
  onSkipFeedback,
  dialogOpen = false,
}) {
  const canContinue = canContinueTriviaFeedback({
    phase,
    onSkipFeedback,
    dialogOpen,
  });

  useEffect(() => {
    if (!canContinue) return undefined;

    const onKeyDown = (event) => {
      if (!shouldHandleTriviaContinueKey(event, true)) return;
      event.preventDefault();
      onSkipFeedback();
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [canContinue, onSkipFeedback]);
}
